<!-- eslint-disable -->
<template lang="pug">
    game-preview-settings(v-if="parameters")
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ $i18n.t('common.common_gameName_equation') }}
        game-preview-setting(v-if="parameters.mode")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}
            span(slot="value") {{ $i18n.t('trainer')[parameters.mode] }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_difficulty') }}
            span(slot="value")
                | {{ textOfDifficulty }}
        game-preview-setting(v-if="parameters.amountOfExamples")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_examples') }}
            span(slot="value") {{ parameters.amountOfExamples }}
        game-preview-setting(v-else-if="parameters.timeLimit")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_timeLimit') }}
            span(slot="value") {{ timeLimit }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_actions') }}
            span(slot="value") {{ parameters.amountOfActions }}
        game-preview-setting(v-if="parameters.amountOfUnknowns")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_unknowns') }}
            span(slot="value") {{ parameters.amountOfUnknowns }}
        game-preview-setting(v-if="parameters.negativeAnswers")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_negativeAnswers') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
        template(v-if="parameters.fractions")
            game-preview-setting
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_fractions') }}
                span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
            game-preview-setting
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numbersAfterPoints') }}
                span(slot="value") {{ parameters.fractionalPart }}
</template>

<script>
    /*eslint-disable*/
    const {noun} = require('plural-ru');
    import TrainerUtilities from '../../../utils/trainer/trainer'
    import GamePreviewSettings from './GamePreviewSettings.vue'
    import GamePreviewSetting from './GamePreviewSetting.vue'

    export default {
        props: ['parameters', 'exerciseId', 'type'],
        mixins: [TrainerUtilities],
        components: {
            GamePreviewSettings,
            GamePreviewSetting
        },
        computed: {
            timeLimit() {
                return this.parameters.timeLimit + ' '
                    + this.$i18n.tc('trainer.trainer_gamePreview_timeParamMinuteDeclination', this.parameters.timeLimit);
            },
            textOfDifficulty() {
                let textOfDifficulty = '';
                switch(this.parameters.difficult) {
                    case "Однозначные цифры":
                        textOfDifficulty = this.$i18n.t('common.common_gameSetting_singleDigitNum');
                        break;
                    case "Двузначные цифры":
                        textOfDifficulty = this.$i18n.t('common.common_gameSetting_doubleDigitsNum');
                        break;
                    case "Трехзначные цифры":
                        textOfDifficulty = this.$i18n.t('common.common_gameSetting_tripleDigitsNum');
                        break;
                    case "Четырехзначные цифры":
                        textOfDifficulty = this.$i18n.t('common.common_gameSetting_fourDigitsNum');
                        break;
                    case "Пятизначные цифры":
                        textOfDifficulty = this.$i18n.t('common.common_gameSetting_fiveDigitsNum');
                        break;
                    case "Шестизначные цифры":
                        textOfDifficulty = this.$i18n.t('common.common_gameSetting_sixDigitsNum');
                        break;
                    case "Семизначные цифры":
                        textOfDifficulty = this.$i18n.t('common.common_gameSetting_sevenDigitsNum');
                        break;
                    case "Восьмизначные цифры":
                        textOfDifficulty = this.$i18n.t('common.common_gameSetting_eightDigitsNum');
                        break;
                }
                if (this.parameters.combining) {
                    return textOfDifficulty + ' (' + this.$i18n.t('trainer.trainer_gameFormSettingValue_combination') + ')';
                }
                return textOfDifficulty;
           }
        }
    }
</script>